import {
  Bell,
  BuildingOffice,
  Calendar,
  CalendarDots,
  CalendarPlus,
  ChartLine,
  Clock,
  ClockCounterClockwise,
  CursorClick,
  Cube,
  FileText,
  Funnel,
  Gauge,
  Globe,
  Lightning,
  ListChecks,
  PlugsConnected,
  Pulse,
  Tag,
  Target,
  Trademark,
  Trophy,
  User,
  UserCircle,
} from "@phosphor-icons/react";

const ICONS = {
  actions: CursorClick,
  activity: Lightning,
  actor: UserCircle,
  alert: Bell,
  assignee: UserCircle,
  brand: Trademark,
  client: User,
  condition: Funnel,
  created: CalendarPlus,
  dashboard: ChartLine,
  dateRange: CalendarDots,
  dueDate: Calendar,
  format: FileText,
  goal: Target,
  industry: BuildingOffice,
  integrations: PlugsConnected,
  interval: Clock,
  metric: Gauge,
  outcome: Trophy,
  platform: Globe,
  progress: ChartLine,
  report: FileText,
  resource: Cube,
  status: Pulse,
  tags: Tag,
  task: ListChecks,
  time: Clock,
  updated: ClockCounterClockwise,
} as const;

export type TableHeaderIconName = keyof typeof ICONS;

export function TableHeaderIcon({ name }: { name: TableHeaderIconName }) {
  const Icon = ICONS[name];

  return (
    <Icon
      aria-hidden="true"
      className="table-header-icon shrink-0 text-foreground transition-colors"
      size={16}
      weight="regular"
    />
  );
}
